import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
export var nbnCard = /*#__PURE__*/css("display:flex;max-width:543px;flex-direction:column;align-items:flex-start;gap:8px;background:", colors.neutral.surface.default, ";margin-top:24px;");
export var card = /*#__PURE__*/css("display:flex;flex-direction:column;align-items:flex-start;align-self:stretch;border-radius:3px;border:1px solid ", colors.neutral.trim.default, ";background:", colors.neutral.surface.default, ";");
export var top = {
  name: "1dojfek",
  styles: "display:flex;padding:16px;align-items:flex-start;gap:16px;align-self:stretch;"
};
export var icon = /*#__PURE__*/css("display:flex;padding:4px;align-items:flex-start;gap:10px;border-radius:10px;background:", colors.accentTwo.subdued.default, ";");
export var content = /*#__PURE__*/css("display:flex;flex-direction:column;align-items:flex-start;flex:1 0 0;gap:4px;color:", colors.neutral.heavy.default, ";");
export var heading = /*#__PURE__*/css(designTokenFonts.bodyBold);
export var subheading = /*#__PURE__*/css(designTokenFonts.mini);
export var subheadingBold = /*#__PURE__*/css(designTokenFonts.miniBold);
export var separator = {
  name: "trhgbg",
  styles: "height:1px;align-self:stretch;"
};
export var bottom = {
  name: "128ax5z",
  styles: "display:flex;padding:8px 16px;justify-content:space-between;align-items:center;align-self:stretch;"
};
export var link = /*#__PURE__*/css("display:flex;align-items:center;gap:4px;color:", colors.primary.base.default, ";cursor:pointer;border:none;background-color:", colors.neutral.surface.default, ";padding:0;", designTokenFonts.mini);
export var disclaimer = /*#__PURE__*/css("display:flex;align-items:center;gap:8px;align-self:stretch;color:", colors.neutral.heavy.default, ";cursor:pointer;border:none;background-color:", colors.neutral.surface.default, ";padding:0;", designTokenFonts.miniBold);